import React from 'react';
import { ActivityLogContent } from '../components/ActivityLog';

export default function ActivityLogPage() {
  return (
    <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e2e8f0', height: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <ActivityLogContent mode="page" />
    </div>
  );
}
